
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule11DataInfoType } from '@/types/Application/FamilyLawMatter/Pdf';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})
export default class Schedule21 extends Vue {

    @Prop({required:true})
    result!: any;
   
    dataReady = false;   
    compInfo = {} as schedule11DataInfoType;
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }
    
    compAnimalFields = [
        {key:"animalName",      label:"Name of companion animal",       tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:35%;"},
        {key:"animalType",      label:"Type of animal",                 tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"animalOwnership", label:"",                               tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:35%;"}
    ]   

    public extractInfo(){
        this.compInfo = this.getCompanionAnimalInfo();
    }

    public getCompanionAnimalInfo(){
       
        let newCompInfo = {} as schedule11DataInfoType;

        newCompInfo = {
            compAnimalInfo: [{animalName: '', animalType:'', animalOwnership: ''}],
            compAnimalFacts: ''
        }

        if (this.result.propertyDivisionCompanionAnimalSurvey){
            newCompInfo.compAnimalInfo = this.result.propertyDivisionCompanionAnimalSurvey;
        }

        if (this.result.companionAnimalFactsSurvey?.animalFacts){
            newCompInfo.compAnimalFacts = this.result.companionAnimalFactsSurvey?.animalFacts;
        }       

        return newCompInfo;
    } 
}
